<div class="row grow header px-5">
  <div class="row grow py-3">
    <div class="column grow">
      @if (!dataSourceLoaded) {
        <div class="row grow center-center">
          <div class="loadingSpinner"></div>
        </div>
      }
      @if (dataSourceLoaded) {
        <div class="row grow with-gap center-center">
          <h4 class="item f-1">
            {{ "Shell.generic.location" | translate }}
          </h4>
          <div class="item f-3">
            <span class="underlined">{{ model?.location }}</span>
          </div>
        </div>
      }

      @if (!dataSourceLoaded) {
        <div class="row grow center-center">
          <div class="loadingSpinner"></div>
        </div>
      }
      @if (dataSourceLoaded) {
        <div class="row grow with-gap center-center">
          <h4 class="item f-1">
            {{ "Shell.generic.size" | translate }}
          </h4>
          <div class="item f-3">
            <span class="underlined"
              >{{ model?.size?.value }}
              {{ model?.size?.symbol }}</span
              >
            </div>
          </div>
        }
      </div>

      <div class="column grow">
        @if (!dataSourceLoaded) {
          <div class="row grow center-center">
            <div class="loadingSpinner"></div>
          </div>
        }
        @if (dataSourceLoaded) {
          <div class="row grow with-gap center-center">
            <h4 class="item f-1">
              {{ "Shell.generic.start" | translate }}
            </h4>
            <div class="item f-3">
              <span class="underlined">{{ model?.start }}</span>
            </div>
          </div>
        }

        @if (!dataSourceLoaded) {
          <div class="row grow center-center">
            <div class="loadingSpinner"></div>
          </div>
        }
        @if (dataSourceLoaded) {
          <div class="row grow with-gap center-center">
            <h4 class="item f-1">
              {{ "Shell.cropCycleTemplates.templateDuration" | translate }}
            </h4>
            @if (model?.currentWeek && model?.weeksCount) {
              <div class="item f-3">
                <span class="underlined">{{
                  "Shell.cropCycleHeader.activeWeeks"
                  | translate: { currentWeek: model?.currentWeek, weeksCount: model?.weeksCount }
                }}</span>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
